
const state = {
    usuario: null,
    loading: false,
    message: "",
    route: "",
}

const actions = {
    _loadingOn(store) {
        store.commit("_loadingOn")
    },
    _loadingOff(store) {
        store.commit("_loadingOff")
    },
    _setMessage(store, message) {
        store.commit("_setMessage", message)
    },
    _clearMessage(store) {
        store.commit("_clearMessage")
    },
    _setRoute(store, route) {
        store.commit("_setRoute", route)
    }
}

const mutations = {
    _loadingOn(state) {
        state.loading = true
    },
    _loadingOff(state) {
        state.loading = false
    },
    _setMessage(state, message) {
        state.message = message
    },
    _clearMessage(state) {
        state.message = ""
    },
    _setRoute(state, route) {
        state.route = route
    }
}

const getters = {
    isLoggedIn: state => state.token.length > 0,
    authStatus: state => state.status,
    _loading: state => state.loading,
    _message: state => state.message,
    _route: state => state.route
}

export const AppStore = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}